import React, { useEffect } from 'react';
import { Box, Container, Grid, Typography, Button, Card, CardContent, Avatar, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ShareIcon from '@mui/icons-material/Share';
import FavoriteIcon from '@mui/icons-material/Favorite';
import CommentIcon from '@mui/icons-material/Comment';
import { Helmet } from 'react-helmet-async';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

export default function WhatsAppMarketingSection() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const features = [
    {
      title: "WhatsApp Business API",
      description: "Leverage WhatsApp's official business API for automated messaging and customer engagement.",
      icon: "📱",
      likes: "3.2K",
      comments: "245"
    },
    {
      title: "Message Templates",
      description: "Create pre-approved message templates for efficient customer communication.",
      icon: "📝",
      likes: "2.9K",
      comments: "198"
    },
    {
      title: "Chatbot Integration",
      description: "Implement AI-powered chatbots for instant customer support and engagement.",
      icon: "🤖",
      likes: "3.4K",
      comments: "256"
    },
    {
      title: "Analytics & Reporting",
      description: "Track message delivery, read rates, and customer engagement metrics.",
      icon: "📊",
      likes: "2.8K",
      comments: "187"
    }
  ];

  const benefits = [
    "Direct customer communication",
    "High engagement rates",
    "Personalized messaging",
    "Cost-effective marketing",
    "Global reach",
    "Real-time responses"
  ];

  return (
    <>
    
<Box
  sx={{
    position: 'fixed',
    top: { xs: 50, sm: 70 },
    left: { xs: 12, sm: 24 },
    zIndex: 1200,
    bgcolor: 'green',
    borderRadius: '50%',
    boxShadow:5,
    width: { xs: 40, sm: 48 },
    height: { xs: 40, sm: 48 },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  <IconButton
    onClick={() => navigate(-1)}
    size="medium"
    sx={{
      color: 'black',
      p: 0.5
    }}
  >
    <ArrowBackIosNewIcon fontSize="small" />
  </IconButton>
</Box>
      <Helmet>
        <title>WhatsApp Marketing Services in Visakhapatnam | SLGT Digital</title>
        <meta
          name="description"
          content="Boost your business with WhatsApp Marketing Services in Visakhapatnam. SLGT Digital helps you connect with your customers using WhatsApp Business API, chatbots, and automation tools."
        />
        <meta
          name="keywords"
          content="WhatsApp Marketing Visakhapatnam, WhatsApp Business API Vizag, WhatsApp Promotions Vizag, WhatsApp Automation Visakhapatnam, Chatbot WhatsApp Vizag, SLGT Digital WhatsApp Services"
        />
        <link rel="canonical" href="https://www.slgt.in/services/whatsapp-marketing" />
      </Helmet>

      <Box sx={{ pt: { xs: 8, sm: 10 }, pb: { xs: 6, sm: 8 }, minHeight: '100vh', bgcolor: '#f0f2f5' }}>
        {/* Hero Section */}
        <Box sx={{ bgcolor: '#ffffff', color: '#075e54', py: { xs: 6, md: 8 }, mb: { xs: 4, md: 6 }, boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
          <Container maxWidth="lg">
            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                  <Avatar sx={{ width: 56, height: 56, mr: 2, bgcolor: '#25d366' }}>WA</Avatar>
                  <Box>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#075e54' }}>WhatsApp Marketing</Typography>
                    <Typography sx={{ color: '#128c7e', fontSize: '0.9rem' }}>Professional WhatsApp Services</Typography>
                  </Box>
                </Box>
                <Typography variant="h1" sx={{ fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' }, fontWeight: 700, mb: 2, color: '#075e54', lineHeight: 1.2 }}>
                  Connect with Customers on WhatsApp
                </Typography>
                <Typography variant="body1" sx={{ fontSize: { xs: '1rem', sm: '1.1rem' }, mb: 3, color: '#128c7e', lineHeight: 1.6 }}>
                  Build meaningful relationships and drive engagement with our expert WhatsApp marketing services.
                </Typography>
                <Button
                  variant="contained"
                  onClick={() => navigate('/requestquotes')}
                  sx={{
                    bgcolor: '#25d366',
                    color: 'white',
                    '&:hover': { bgcolor: '#128c7e' },
                    px: { xs: 4, sm: 6 },
                    py: { xs: 1.5, sm: 2 },
                    fontSize: { xs: '1rem', sm: '1.1rem' },
                    fontWeight: 600,
                    borderRadius: '6px',
                    textTransform: 'none'
                  }}
                >
                  Get Started
                </Button>
              </Grid>
              <Grid item xs={12} md={6} sx={{ display: { xs: 'none', md: 'block' } }}>
                <img
                  src="/assets/services/wm-1.png"
                  alt="WhatsApp Marketing Illustration"
                  style={{
                    width: '100%',
                    maxWidth: '500px',
                    height: 'auto',
                    display: 'block',
                    margin: '0 auto',
                    borderRadius: '8px'
                  }}
                />
              </Grid>
            </Grid>
          </Container>
        </Box>

        {/* Features Section */}
        <Container maxWidth="lg" sx={{ mb: 6 }}>
          <Typography variant="h2" sx={{ textAlign: 'center', fontSize: '2rem', fontWeight: 700, mb: 4, color: '#075e54' }}>
            Our WhatsApp Marketing Services
          </Typography>
          <Grid container spacing={3}>
            {features.map((feature, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Card sx={{ height: '100%', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.1)', bgcolor: '#ffffff' }}>
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <Avatar sx={{ width: 40, height: 40, mr: 2, bgcolor: '#25d366' }}>{feature.icon}</Avatar>
                      <Box>
                        <Typography sx={{ fontWeight: 600, color: '#075e54' }}>{feature.title}</Typography>
                        <Typography sx={{ fontSize: '0.9rem', color: '#128c7e' }}>Online</Typography>
                      </Box>
                    </Box>
                    <Typography sx={{ color: '#075e54', fontSize: '1rem', lineHeight: 1.6 }}>
                      {feature.description}
                    </Typography>
                    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton size="small" sx={{ color: '#25d366' }}><FavoriteIcon /></IconButton>
                        <Typography sx={{ color: '#128c7e', fontSize: '0.9rem' }}>{feature.likes}</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton size="small" sx={{ color: '#128c7e' }}><CommentIcon /></IconButton>
                        <Typography sx={{ color: '#128c7e', fontSize: '0.9rem' }}>{feature.comments}</Typography>
                      </Box>
                      <IconButton size="small" sx={{ color: '#128c7e' }}><ShareIcon /></IconButton>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* Benefits Section */}
        <Box sx={{ bgcolor: '#ffffff', py: 6 }}>
          <Container maxWidth="lg">
            <Typography variant="h2" sx={{ textAlign: 'center', fontSize: '2rem', fontWeight: 700, mb: 4, color: '#075e54' }}>
              Benefits of WhatsApp Marketing
            </Typography>
            <Grid container spacing={3}>
              {benefits.map((benefit, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card sx={{ borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.1)', bgcolor: '#ffffff' }}>
                    <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar sx={{ width: 40, height: 40, mr: 2, bgcolor: '#25d366' }}>✓</Avatar>
                      <Typography sx={{ fontSize: '1rem', color: '#075e54', fontWeight: 500 }}>{benefit}</Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>

        {/* CTA Section */}
        <Container maxWidth="lg" sx={{ mt: 6, textAlign: 'center' }}>
          <Card sx={{ borderRadius: '8px', boxShadow: '0 1px 2px rgba(0,0,0,0.1)', bgcolor: '#ffffff', p: 4 }}>
            <Typography variant="h2" sx={{ fontSize: '2rem', fontWeight: 700, mb: 3, color: '#075e54' }}>
              Ready to Connect with Your Customers?
            </Typography>
            <Typography sx={{ mb: 4, fontSize: '1.1rem', color: '#128c7e', lineHeight: 1.6 }}>
              Let's create a powerful WhatsApp marketing strategy that helps you build lasting relationships with your customers.
            </Typography>
            <Button
              variant="contained"
              onClick={() => navigate('/requestquotes')}
              sx={{
                bgcolor: '#25d366',
                color: 'white',
                '&:hover': { bgcolor: '#128c7e' },
                px: 6,
                py: 2,
                fontSize: '1.1rem',
                fontWeight: 600,
                borderRadius: '6px',
                textTransform: 'none'
              }}
            >
              Request a Quote
            </Button>
          </Card>
        </Container>
      </Box>
    </>
  );
}
